import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const MobileGeneratorIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="0.387756" width="16" height="16" rx="3.92727" fill={fillColor || 'white'} />
      <path d="M9.04232 7.34548H11.006L7.73323 11.9273V8.65457H5.76959L9.04232 4.07275V7.34548Z" fill={fillColor || '#FF5B27'} />
    </svg>
  );
};

export { MobileGeneratorIcon };
